<template>
  <div>
    <vs-popup
      classContent="popup-example"
      :title="fetchtoSentenceCase()"
      :active.sync="assignOpen"
    >
      <vs-row>
        <vs-col vs-w="12" class="mb-4">
          <label>Report Name</label>
          <vs-input
            v-model="couseWorkPayload.title"
            v-validate="'required'"
            class="w-full"
            icon-pack="feather"
            icon="icon-edit"
            icon-after
          />
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-w="12" class="mb-4">
          <div style="width: 190px">
            <vs-checkbox v-model="couseWorkPayload.has_deadline"
              >Deadline required</vs-checkbox
            >
          </div>
          <div
            style="width: calc(100% - 190px)"
            v-if="couseWorkPayload.has_deadline"
          >
            <flat-pickr
              v-model="couseWorkPayload.deadline"
              class="w-full my-2"
              :config="assignType=='reassign'?{'minDate': dataObj.assignment_builder.deadline?$moment(dataObj.assignment_builder.deadline).format('YYYY-MM-DD'):'today' , 'enableTime': true}:{ 'minDate':'today', 'enableTime': true,}"
              name="start_date"
              data-vv-name="start_date"
              v-validate="'required'"
            ></flat-pickr>
          </div>
        </vs-col>
        <vs-col vs-w="12"  v-if="couseWorkPayload.has_deadline">
          <vs-checkbox v-model="couseWorkPayload.has_submit_after_deadline"
            >Allow Reports to be submitted after deadline</vs-checkbox
          >
        </vs-col>
      </vs-row>
      <vs-divider />
      <vs-row>
        <vs-col vs-w="12" class="mb-4">
          <vs-input
            @keyup="searchFun"
            v-model="filterPayload.teacher_name"
            class="w-full"
            type="text"
            placeholder="Search Teacher Name"
          />
        </vs-col>
        <vs-col vs-w="12">
          <h6 class="mb-2">Filter Teacher by:</h6>
        </vs-col>
        <!-- <vs-col vs-lg="4" vs-sm="12" class="p-1">
          <label>Subject</label>
          <v-select
            multiple
            :reduce="(option) => option.id"
            @input="getTeacherList"
            v-model="filterPayload.subject_id"
            label="subject_name"
            class="w-full h-full"
            placeholder="Filter Subject"
            :options="subjectlist"
            :clearable="false"
          ></v-select>
        </vs-col> -->
        <vs-col vs-lg="6" vs-sm="12" class="p-1">
          <label>Course</label>
          <v-select
            @input="getTeacherList"
            placeholder="Filter Course"
            v-model="filterPayload.course_id"
            :options="courseList"
            :reduce="(course) => course.id"
            label="name"
            @open="onOpen"
            @close="onClose"
          >
            <template #list-footer>
              <li ref="load" class="loader" v-show="course_list_meta.has_next">
                Loading more courses...
              </li>
            </template>
          </v-select>
        </vs-col>
        <vs-col vs-lg="6" vs-sm="12" class="p-1">
          <label>Student</label>
          <v-select
            @input="getTeacherList"
            :reduce="(option) => option.client_users_id"
            v-model="filterPayload.client_user_id"
            :getOptionLabel="(item) => `${item.first_name} ${item.last_name}`"
            class="w-full h-full"
            placeholder="Filter Student"
            @open="onOpenStudent"
            @close="onCloseStudent"
            :options="studentlist"
            @search="funSearch"
          >
            <template v-slot:selected-option="studentlist">
              <img
                v-if="studentlist.picture"
                class="person-img rounded-full"
                :src="studentlist.picture"
              />
              <img
                v-else
                class="person-img rounded-full"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
              {{ studentlist.first_name }}
              {{ studentlist.last_name }}
            </template>
            <template v-slot:option="studentlist">
              <img
                v-if="studentlist.picture"
                class="person-img rounded-full"
                :src="studentlist.picture"
              />
              <img
                v-else
                class="person-img rounded-full"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
              {{ studentlist.first_name }}
              {{ studentlist.last_name }}
            </template>
            <template #list-footer>
              <li ref="loadStudent" class="loader" v-show="meta.has_next">
                Loading more students...
              </li>
            </template>
          </v-select>
        </vs-col>

        <vs-divider />
        <div class="w-full" v-if="selectedTeacher.length > 0">
          <h6 class="mb-4">Selected Teacher :</h6>
          <div class="flex flex-wrap mb-4">
            <div
              class="text-center mr-1"
              v-for="(selectedUser, index2) in selectedTeacher"
              :key="index2"
            >
              <div class="selected-names" style="width: 30px; height: 30px">
                <img
                  v-if="selectedUser.picture"
                  class="person-img rounded-full shadow-md block"
                  :src="selectedUser.picture"
                />
                <img
                  v-else
                  class="person-img rounded-full shadow-md block"
                  src="@/assets/images/pages/user-circle-solid.svg"
                />
                <span
                  @click="closeSelectedUser2(index2)"
                  style="width: 15px; height: 15px; font-size: 12px"
                  class="close"
                  >&times;</span
                >
              </div>
              <p class="name-selected">
                {{ selectedUser.first_name }} {{ selectedUser.last_name }}
              </p>
            </div>
          </div>
          <vs-divider />
        </div>
        <h6 class="w-full mb-4">Select Teacher</h6>
        <div
          style="max-height: calc(100vh - 350px); overflow: auto"
          class="vertical_scrollbar w-full p-2 relative"
          @scroll="detectsScrollLength()"
          ref="element"
        >
          <vs-table
            class="checkbox_removed_vstable cstm_vuexy_table w-full"
            multiple
            v-model="selectedTeacher"
            :data="teacherList"
          >
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td class="avatar_name_td" :data="data[indextr].first_name">
                  <img
                    v-if="data[indextr].picture"
                    class="person-img rounded-full shadow-md block"
                    :src="data[indextr].picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full shadow-md block"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                  <span>
                    {{ data[indextr].first_name }}
                    {{ data[indextr].last_name }}
                  </span>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-row>
      <vs-button @click="convertToCourseWork">Proceed</vs-button>
    </vs-popup>
  </div>
</template>
<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { createCourseWork } from '@/api/assignment-question'
import { fetchUserClient } from '@/api/task-project.js'
import { shortCourseList } from '@/api/admission'
import vSelect from 'vue-select'
export default {
  components: {
    vSelect,
    flatPickr
  },
  data () {
    return {
      pageLimitSet: 20,
      assignOpen: false,
      configdeadlineDate: {
        enableTime: true,
        minDate: new Date()
      },
      meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      teacher_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      subjectlist: [],
      teacherList: [],
      studentlist: [],
      selectedTeacher: [],
      courseList: [],
      filterPayload: {
        course_id: null,
        subject_id: [],
        client_user_id: '',
        teacher_name: ''
      },
      course_list_meta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      customer_id: '',
      observerCourse: new IntersectionObserver(this.loadMoreCourses),
      observer: new IntersectionObserver(this.loadMoreStudent),
      couseWorkPayload: {
        user_type: 1,
        title: '',
        has_deadline: false,
        has_submit_after_deadline: false,
        deadline: '',
        assignment_type: this.dataObj.assignment_type
      },
      has_all_subject: false,
      name:''
    }
  },
  props: {
    assignOpenModal: {
      type: Boolean
    },
    assignType: {
      type: String
    },

    dataObj: {}
  },
  watch: {
    assignOpen () {
      if (this.assignOpen === false) {
        this.$emit('assignclose', true)
      }
    }
  },
  created () {
    this.assignOpen = this.assignOpenModal
    this.customer_id = localStorage.getItem('customer_id')
  },
  mounted () {
    this.fetchStudentList()
    this.getCourseOptions()
    this.getTeacherList()

    if (this.assignType === 'reassign') {
      this.couseWorkPayload.title = this.dataObj.assignment_builder.title
      this.couseWorkPayload.has_deadline =
        this.dataObj.assignment_builder.has_deadline
      this.couseWorkPayload.has_submit_after_deadline =
        this.dataObj.assignment_builder.has_submit_after_deadline
      this.couseWorkPayload.deadline = this.dataObj.assignment_builder.deadline
      this.subjectlist = this.dataObj.assignment_builder.subject
      this.couseWorkPayload.assignment_type =
        this.dataObj.assignment_builder.assignment_type
      this.has_all_subject = this.dataObj.assignment_builder.has_all_subject
      this.selectedTeacher = [this.dataObj.teacher]
    } else {
      this.subjectlist = this.dataObj.subject
    }
  },
  methods: {
    async funSearch (search) {

      try {
        this.name = search
        if (search !== '') {
          console.log(search)

          this.studentlist = this.studentlist.filter((ele) => {
            if (ele.first_name.includes(search) || ele.last_name.includes(search)) {
              return ele
            }
          })
          if (this.studentlist.length == 0) {
            const payload = {
              ...this.filterPayload,
              name:this.name
            }

            const data = await fetchUserClient(
              'Client',
              this.customer_id,
              {},
              payload
            )
            this.studentlist = data.data.data.users_list
            this.meta = data.data.data.meta
            this.meta.page = data.data.data.meta.current_page
          }

        }
      } catch (e) {
        //
      }
    },
    fetchtoSentenceCase () {
      return (this.assignType.charAt(0).toUpperCase() + this.assignType.slice(1))
    },
    async getTeacherList () {
      try {
        const payload = {
          ...this.filterPayload,
          name:this.filterPayload.teacher_name
        }

        const { data } = await fetchUserClient(
          'User',
          this.customer_id,
          this.teacher_meta,
          payload
        )
        this.teacherList = data.data.users_list
        this.teacher_meta = data.data.meta
        this.teacher_meta.page = data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    detectsScrollLength () {
      if (
        Math.ceil(
          this.$refs.element.scrollTop + this.$refs.element.offsetHeight
        ) >= this.$refs.element.scrollHeight
      ) {
        this.loadMoreTeacher()
      }
    },
    async loadMoreStudent () {
      try {
        const payload = {
          ...this.filterPayload,
          name:this.filterPayload.teacher_name
        }
        this.meta.page = this.meta.page + 1
        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.meta,
          payload
        )

        this.studentlist =  this.studentlist.filter((ele) => {
          if (ele.client_users_id != data.data.data.users_list.map((item) => {
            return item.client_users_id

          })) return ele
        })
        this.studentlist.push(...data.data.data.users_list)
        this.meta = data.data.data.meta
        this.meta.page = data.data.data.meta.current_page

        // if(this.assignType=='reassign'){
        //   this.studentlist = this.studentlist.filter(ele=>ele.client_users_id != this.dataObj.client_user.client_users_id)
        // }
      } catch (e) {
        //
      }
    },
    searchFun () {
      this.fetchTeacherListByName(this)
    },
    fetchTeacherListByName: _.debounce(async (vm) => {
      vm.teacher_meta.page = 1
      vm.getTeacherList()
    }, 2000),
    async convertToCourseWork () {
      try {
        const users = []
        this.selectedTeacher.forEach((ele) => {
          users.push(ele.id)
        })
        const payload = {
          subjects:
            this.filterPayload.subject_id.length > 0
              ? this.filterPayload.subject_id
              : [],
          has_all_subject: this.dataObj.has_all_subject
            ? this.dataObj.has_all_subject
            : this.has_all_subject,
          ...this.couseWorkPayload,
          users,
          assignment_builder_id:
            this.assignType === 'reassign'
              ? this.dataObj.assignment_builder.id
              : this.dataObj.id,
          is_reassigned: this.assignType === 'reassign'
        }
        if (payload.has_deadline && !payload.deadline) {
          return this.$vs.notify({
            title: 'Warning',
            text: 'Please select a deadline date',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 3000
          })
        }

        if (payload.has_deadline) payload.deadline = `${payload.deadline  }:00`

        if (payload.users.length === 0) {
          return this.$vs.notify({
            title: 'Warning',
            text: 'Please select at least one teacher',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 3000
          })
        }

        await createCourseWork(payload, this.customer_id)
        this.$vs.notify({
          title: 'Success',
          text: `${ this.assignType === 'reassign' ? 'Report reassigned' : 'Template assigned'}  successfully`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        this.$emit('assignclose', true)
        this.assignOpen = false

      } catch (e) {
        console.log(e)
        this.$vs.notify({
          title: 'Error',
          text: 'Something went wrong',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
      }
    },
    async fetchStudentList (search) {
      try {
        if (search) {
          this.meta={}
        }
        const payload = {
          name:this.name,
          ...this.filterPayload

        }
        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.meta,
          payload
        )
        this.studentlist = data.data.data.users_list
        this.meta = data.data.data.meta
        this.meta.page = data.data.data.meta.current_page
        // if(this.assignType=='reassign'){
        //   this.studentlist = this.studentlist.filter(ele=>ele.client_users_id != this.dataObj.client_user.client_users_id)
        // }
      } catch (e) {
        //
      }
    },
    closeSelectedUser2 (index) {
      this.selectedTeacher.splice(index, 1)
    },
    async getCourseOptions () {
      try {
        const payload = {
          // subject_id: this.filterPayload.subject_id
        }
        const { data } = await shortCourseList(
          localStorage.getItem('customer_id'),
          payload, this.course_list_meta
        )
        this.courseList = data.data.course_list

        this.course_list_meta = data.data.meta
        //this.fetchStudentList()
      } catch (e) {
        //
      }
    },
    async onOpen () {
      if (this.course_list_meta.has_next) {
        await this.$nextTick()
        this.observerCourse.observe(this.$refs.load)
      }
    },
    onClose () {
      this.observerCourse.disconnect()
    },
    async onOpenStudent () {
      if (this.meta.has_next) {
        await this.$nextTick()
        this.observer.observe(this.$refs.loadStudent)
      }
    },
    onCloseStudent () {
      this.observer.disconnect()
    },
    async loadMoreCourses () {
      // if (isIntersecting) {
      //   const ul = target.offsetParent;
      //   const scrollTop = target.offsetParent.scrollTop;

      try {
        const payload = {
          subject_id: this.filterPayload.subject_id
        }
        this.course_list_meta.current_page = this.course_list_meta.current_page + 1
        const { data } = await shortCourseList(
          localStorage.getItem('customer_id'),
          payload, this.course_list_meta
        )
        this.courseList.push(...data.data.course_list)
        this.course_list_meta = data.data.meta
      } catch (e) {
        //
      }

      // await this.$nextTick();
      // ul.scrollTop = scrollTop;
      // }
    },
    async loadMoreTeacher () {
      const payload = {
        ...this.filterPayload
      }
      this.teacher_meta.page = this.teacher_meta.page + 1
      const { data } = await fetchUserClient(
        'User',
        this.customer_id,
        this.teacher_meta,
        payload
      )
      this.teacherList.push(...data.data.users_list)
      this.teacher_meta = data.data.meta
      this.teacher_meta.page = data.data.meta.current_page
    }
  }
}
</script>
